import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareReleaseNotesRoute: InvariantJiraRoute = {
	name: 'software-release-notes',
	path: '/secure/ReleaseNote.jspa',
	query: ['projectId'],
};
